var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatPumpOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4997 30.8528H43.1663C42.4293 30.8528 41.833 30.2565 41.833 29.5195C41.833 28.7825 42.4294 28.1862 43.1663 28.1862H52.4997C53.2367 28.1862 53.833 28.7825 53.833 29.5195C53.833 30.2565 53.2367 30.8528 52.4997 30.8528Z",
    fill: "url(#paint0_linear_34666_9965)",
    stroke: "url(#paint1_linear_34666_9965)",
    strokeWidth: 0.467758
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4997 37.5195H43.1663C42.4293 37.5195 41.833 36.9232 41.833 36.1862C41.833 35.4492 42.4294 34.8528 43.1663 34.8528H52.4997C53.2367 34.8528 53.833 35.4492 53.833 36.1862C53.833 36.9232 53.2367 37.5195 52.4997 37.5195Z",
    fill: "url(#paint2_linear_34666_9965)",
    stroke: "url(#paint3_linear_34666_9965)",
    strokeWidth: 0.467758
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4997 44.1862H43.1663C42.4293 44.1862 41.833 43.5898 41.833 42.8529C41.833 42.1159 42.4294 41.5195 43.1663 41.5195H52.4997C53.2367 41.5195 53.833 42.1159 53.833 42.8529C53.833 43.5898 53.2367 44.1862 52.4997 44.1862Z",
    fill: "url(#paint4_linear_34666_9965)",
    stroke: "url(#paint5_linear_34666_9965)",
    strokeWidth: 0.467758
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4997 23.5195H43.1663C42.4293 23.5195 41.833 22.9231 41.833 22.1862V13.5195C41.833 12.7825 42.4294 12.1862 43.1663 12.1862H52.4997C53.2367 12.1862 53.833 12.7825 53.833 13.5195V22.1862C53.833 22.9232 53.2367 23.5195 52.4997 23.5195ZM44.4997 20.8528H51.1663V14.8528H44.4997V20.8528Z",
    fill: "url(#paint6_linear_34666_9965)",
    stroke: "url(#paint7_linear_34666_9965)",
    strokeWidth: 0.467758
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.166 14.8528C30.5173 14.8528 36.4993 20.8346 36.4993 28.1862C36.4993 35.5377 30.5175 41.5195 23.166 41.5195C15.8145 41.5195 9.83268 35.5377 9.83268 28.1862C9.83268 20.8346 15.8145 14.8528 23.166 14.8528ZM23.166 12.1862C14.3273 12.1862 7.16602 19.3475 7.16602 28.1862C7.16602 37.0248 14.3273 44.1862 23.166 44.1862C32.0047 44.1862 39.166 37.0248 39.166 28.1862C39.166 19.3475 32.0047 12.1862 23.166 12.1862Z",
    fill: "url(#paint8_linear_34666_9965)",
    stroke: "url(#paint9_linear_34666_9965)",
    strokeWidth: 0.467758
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3985 27.4782C31.1954 26.5693 29.7371 26.1058 28.0626 26.1058C27.573 26.1058 27.0965 26.1474 26.6407 26.2126C26.3308 25.6188 25.8777 25.111 25.3256 24.7386C25.6381 24.3923 25.9923 24.1397 26.3855 24.0642C26.9818 23.947 27.8151 23.9652 28.5625 24.0069C28.8959 24.0251 29.2162 24.0433 29.5157 24.0433C30.0834 24.0433 31.4089 24.0433 31.9714 22.7829C32.1641 22.3506 32.1381 21.8428 31.8933 21.2751C31.2031 19.6736 28.6953 17.6007 26.5287 16.8429C25.3333 16.4236 24.1823 16.2126 23.1042 16.2126C20.224 16.2126 18.2448 17.7569 17.9349 20.2439C17.6485 22.5382 18.6068 24.46 19.737 25.8871C19.388 26.4262 19.1641 27.0564 19.1094 27.7334C18.6745 27.6397 18.2579 27.4704 17.987 27.1605C17.513 26.6163 17.1771 25.9496 16.849 25.3037C16.2318 24.0824 15.586 22.8037 14.0834 22.9626C13.612 23.0121 13.1849 23.2881 12.8178 23.7829C11.7761 25.1814 11.2345 28.3897 11.6589 30.6449C12.3595 34.3637 14.4975 36.7673 17.1043 36.7673C17.7006 36.7673 18.3048 36.6397 18.8985 36.3897C21.0079 35.4991 22.1928 33.7361 22.8647 32.0564C22.9376 32.0616 23.0131 32.0668 23.086 32.0668C23.7058 32.0668 24.2917 31.921 24.8152 31.671C24.948 32.1007 24.9845 32.5199 24.8569 32.8897C24.6225 33.5694 24.2136 34.197 23.8178 34.8012C23.1017 35.9001 22.2865 37.1449 23.1746 38.3663C23.5157 38.8377 24.1147 39.0772 24.9532 39.0772C26.7345 39.0772 29.4636 37.9783 31.0392 36.6267C33.0938 34.8611 34.2371 32.7517 34.1746 30.835C34.1381 29.4835 33.5183 28.3246 32.3985 27.4782L32.3985 27.4782ZM17.8592 33.9235C17.5936 34.0355 17.3384 34.0928 17.1014 34.0928C15.8775 34.0928 14.716 32.4678 14.2785 30.1449C14.0597 28.9834 14.2238 27.5485 14.4842 26.5355C14.8436 27.2464 15.2914 28.124 15.9738 28.9079C16.8592 29.9235 18.1873 30.4495 19.9165 30.4886C20.0623 30.6787 20.2264 30.8558 20.4035 31.0172C19.94 32.1839 19.1639 33.374 17.8592 33.9235L17.8592 33.9235ZM23.0884 29.3922C22.354 29.3922 21.7577 28.7933 21.7577 28.0563C21.7577 27.3219 22.354 26.723 23.0884 26.723C23.8254 26.723 24.4243 27.3193 24.4243 28.0563C24.4243 28.7933 23.8254 29.3922 23.0884 29.3922ZM22.4972 24.1058C22.2759 24.1396 22.0597 24.1865 21.8514 24.2542C21.0597 23.2646 20.4035 21.986 20.5806 20.5694C20.7212 19.447 21.5702 18.8766 23.1041 18.8766C23.8697 18.8766 24.7499 19.0433 25.6457 19.3584C26.7603 19.749 27.9244 20.6084 28.6692 21.3428C28.3202 21.3246 27.9244 21.3011 27.5155 21.3011C26.9088 21.3011 26.3697 21.348 25.8697 21.447C24.3228 21.749 23.2395 22.8818 22.4973 24.1058L22.4972 24.1058ZM29.3072 34.5924C28.4635 35.319 27.1432 35.9258 26.078 36.2174C26.5129 35.5508 27.0468 34.7252 27.3853 33.7461C27.8905 32.28 27.4712 30.7982 26.802 29.556C26.8931 29.332 26.966 29.1003 27.0155 28.858C27.3567 28.8086 27.7056 28.7721 28.065 28.7721C29.1613 28.7721 30.052 29.0429 30.7942 29.6054C31.2707 29.9648 31.5025 30.3815 31.5181 30.9101C31.5494 31.9986 30.7238 33.3736 29.3072 34.5924L29.3072 34.5924Z",
    fill: "url(#paint10_linear_34666_9965)",
    stroke: "url(#paint11_linear_34666_9965)",
    strokeWidth: 0.467758
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1667 4.18616H5.83333C2.90107 4.18616 0.5 6.58722 0.5 9.51949V46.8528C0.5 49.7851 2.90107 52.1862 5.83333 52.1862H8.5V54.8528C8.5 55.5898 9.09635 56.1862 9.83333 56.1862H17.1667C17.9037 56.1862 18.5 55.5898 18.5 54.8528V52.1862H42.5V54.8528C42.5 55.5898 43.0964 56.1862 43.8333 56.1862H51.1667C51.9037 56.1862 52.5 55.5898 52.5 54.8528V52.1862H55.1667C58.0989 52.1862 60.5 49.7851 60.5 46.8528V9.51949C60.5 6.58722 58.0989 4.18616 55.1667 4.18616ZM15.8333 53.5195H11.1667V52.1862H15.8333V53.5195ZM49.8333 53.5195H45.1667V52.1862H49.8333V53.5195ZM57.8333 46.8528C57.8333 48.3242 56.638 49.5195 55.1667 49.5195H5.83333C4.362 49.5195 3.16667 48.3242 3.16667 46.8528V9.51949C3.16667 8.04816 4.362 6.85282 5.83333 6.85282H55.1667C56.638 6.85282 57.8333 8.04816 57.8333 9.51949V46.8528Z",
    fill: "url(#paint12_linear_34666_9965)",
    stroke: "url(#paint13_linear_34666_9965)",
    strokeWidth: 0.467758
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34666_9965",
    x1: 50.7296,
    y1: 28.8727,
    x2: 49.8642,
    y2: 33.8365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34666_9965",
    x1: 50.7296,
    y1: 28.8727,
    x2: 49.8642,
    y2: 33.8365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34666_9965",
    x1: 50.7296,
    y1: 35.5394,
    x2: 49.8642,
    y2: 40.5032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34666_9965",
    x1: 50.7296,
    y1: 35.5394,
    x2: 49.8642,
    y2: 40.5032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34666_9965",
    x1: 50.7296,
    y1: 42.206,
    x2: 49.8642,
    y2: 47.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34666_9965",
    x1: 50.7296,
    y1: 42.206,
    x2: 49.8642,
    y2: 47.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34666_9965",
    x1: 50.7296,
    y1: 15.1038,
    x2: 40.3316,
    y2: 29.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34666_9965",
    x1: 50.7296,
    y1: 15.1038,
    x2: 40.3316,
    y2: 29.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34666_9965",
    x1: 30.8903,
    y1: 20.4243,
    x2: 1.08354,
    y2: 58.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_34666_9965",
    x1: 30.8903,
    y1: 20.4243,
    x2: 1.08354,
    y2: 58.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34666_9965",
    x1: 28.3159,
    y1: 22.0989,
    x2: 6.97436,
    y2: 49.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34666_9965",
    x1: 28.3159,
    y1: 22.0989,
    x2: 6.97436,
    y2: 49.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_34666_9965",
    x1: 44.9829,
    y1: 17.5731,
    x2: -1.39258,
    y2: 85.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_34666_9965",
    x1: 44.9829,
    y1: 17.5731,
    x2: -1.39258,
    y2: 85.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPumpOrangeIcon);
export default __webpack_public_path__ + "static/media/heat_pump_orange_icon.f525a61fb0e863644b0127e7e9527532.svg";
export { ForwardRef as ReactComponent };